import React from 'react';
import { css } from '@emotion/react';
import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { readableColorOnBackground } from '$/utils/colors';
import Submit, { SubmitButtonProps } from './Submit';
import isMobile from '$/utils/isMobile';

export const InRoomButton: React.FC<SubmitButtonProps> = withWebinarPlayerContext(
  ['ewebinar'],
  'InRoomButton'
)(({ context, ...props }) => {
  const { ewebinar } = context;
  const bgColor = ewebinar.themeSettings.actionColor || ewebinar.themeSettings.primaryColor;
  const fgColor = readableColorOnBackground(bgColor);
  return (
    <Submit
      {...props}
      className={`
        button-inroom
        ${props.className}
        ${isMobile && 'is-mobile'}
      `}
      theme={{
        fg: fgColor,
        fgHover: fgColor,
        bg: bgColor,
        bgHover: bgColor,
      }}
      css={css`
        text-transform: uppercase;
        padding: 0.75rem 2rem;
        div {
          font-size: 1.25rem;
        }
        border-radius: ${ewebinar.themeSettings.borderRadius}px;
      `}
    />
  );
});
